import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import SolutionsSection from "./components/SolutionsSection";
import StatsSection from "./components/StatsSection";
import PartnerBrandsSection from "./components/PartnerBrandsSection";
import IndustriesSection from "./components/IndustriesSection";
import CaseStudiesSection from "./components/CaseStudiesSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <SolutionsSection />
        <StatsSection />
        <PartnerBrandsSection />
        <IndustriesSection />
        <CaseStudiesSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
